
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/abitur",
      function () {
        return require("private-next-pages/abitur/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/abitur"])
      });
    }
  